// noinspection JSUnresolvedReference

import React, { useEffect, useRef, useState } from 'react'
import './styles.scss'
import { Trans, useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import Lightbox from '../../../Shared/Lightbox'
import Stars from '../../../Shared/Stars'
import Row from '../../../Shared/GridGM'
import Col from '../../../Shared/GridGM/Col'
import { getOffer } from '../../../../http/driveApiGateway/client'
import Alert from '../../../Shared/Alert'

const OfferContent = ({ giataId, operatorId, offerId }) => {
  const [activeImage, setActiveImage] = useState(0)
  const [loading, setLoading] = useState(true)
  const [offer, setOffer] = useState(null)
  const [error, setError] = useState(false)
  const lightboxRef = useRef(null)
  const { t } = useTranslation()

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'instant' })
  }

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true)
      setError(false)
      try {
        const response = await getOffer(giataId, operatorId, offerId).fetchPromise
        setOffer(response)
      } catch (error) {
        setError(true)
      } finally {
        setLoading(false)
        scrollToTop()
      }
    }
    fetchData().catch(() => {})
  }, [giataId, operatorId, offerId])

  const openLightbox = () => {
    lightboxRef.current?.openLightbox()
  }
  const onThumbClick = (index) => {
    setActiveImage(index)
  }

  if (loading) {
    return null;
  }
  if (error) {
    return <Alert type={'danger'}>{t('DEFAULT_ERROR_MESSAGE')}</Alert>
  }
  const lightboxImages = offer.images.map((image) => {
    let displayUrl
    if (image.sizes.hasOwnProperty('2160')) {
      displayUrl = image.sizes['2160']['href']
    } else {
      displayUrl = image.sizes['800']['href']
    }
    return { ...image, displayUrl }
  })
  return (
    <div className={'TourOperatorDetail'}>
      <Lightbox images={lightboxImages} index={activeImage}
                captions={offer.name + ' | ' + offer.bookingCodes.join(', ') + ' | ' + offer.catalogName + ' | ' + offer.duration}
                ref={lightboxRef}></Lightbox>
      <img alt={'logo'} className={'TourOperatorDetail-Logo'} src={offer.logo}/>
      <h2>{offer.name} <Stars count={offer.rating}></Stars></h2>
      <Trans>LABEL_PRODUCT_CODE</Trans>:&nbsp;
      {offer.bookingCodes.join(', ')}
      <br/>
      <Row gap="large">
        <Col cols="6">
          <div className={'TourOperatorDetail-Facts'}>
            <span><Trans>LABEL_CITY</Trans>:</span> {offer.cityName}<br/>
            <span><Trans>LABEL_DESTINATION</Trans>:</span> {offer.destinationName}<br/>
            <span><Trans>LABEL_COUNTRY</Trans>:</span> {offer.countryName}<br/>
          </div>
        </Col>
        <Col cols="6">
          <div className={'TourOperatorDetail-Facts'}>
            <span><Trans>LABEL_CATALOG</Trans>:</span> {offer.catalogName}<br/>
            <span><Trans>LABEL_VALIDITY_PERIOD</Trans>:</span> {offer.duration}<br/>
            <span><Trans>LABEL_PAGE</Trans>:</span> {offer.page}<br/>
          </div>
          {offer.pdf !== undefined &&
            <a href={offer.pdf} target="_blank" rel={'noreferrer'}><i className={'im im-download'}></i>
              <Trans>LINK_DOWNLOAD_CATALOG</Trans></a>
          }
        </Col>
      </Row>

      <hr/>

      <Row gap="large">
        <Col cols="6">
          <div className={'TourOperatorDetail-Text'} dangerouslySetInnerHTML={{ __html: offer.text }}></div>
        </Col>
        <Col cols="6">
          {(offer.images.length ? (
            <div className={'TourOperatorDetail-Images'}>
              <img alt={''} className={'TourOperatorDetail-Images-Main'}
                   src={offer.images[activeImage].sizes['800'].href}
                   onClick={openLightbox}/>
              <div className={'TourOperatorDetail-Images-Thumbs'}>
                {offer.images.map((image, index) => {
                  return (
                    <div key={index}
                         className={'TourOperatorDetail-Images-Thumb TourOperatorDetail-Images-Thumb-' + (index === activeImage ? 'Active' : '')}
                         style={{ backgroundImage: 'url(' + image.sizes['150'].href + ')' }}
                         onClick={() => onThumbClick(index)}></div>
                  )
                })}
              </div>
            </div>
          ) : null)}
        </Col>
      </Row>
    </div>
  )
}

OfferContent.propTypes = {
  giataId: PropTypes.number.isRequired,
  operatorId: PropTypes.number.isRequired,
  offerId: PropTypes.number.isRequired,
}

export default OfferContent
